import {
  apiClient,
  Auth,
  Pagination,
  PaginationSearchParams,
} from '@/shared/api'
import { getCookie } from '@/shared/lib/server'

import { TRecentViewedRoom } from '../model/schema'

export const getRecentViewedRooms = async () => {
  const uuid = await getCookie('uuid')

  const { data } = await apiClient.get<TRecentViewedRoom[]>({
    endpoint: `/rooms/recent/view`,
    queryParams: { uuid },
  })

  return data
}

export type RecentViewedRoomsSearchParams = PaginationSearchParams

export const getRecentViewedRoomsWithPagination = async ({
  size = 10,
  ...restParams
}: RecentViewedRoomsSearchParams) => {
  const uuid = await getCookie('uuid')

  const { data } = await apiClient.get<Pagination<TRecentViewedRoom>>({
    endpoint: `/rooms/recent-views`,
    queryParams: {
      uuid,
      size,
      ...restParams,
    },
    auth: Auth.OPTIONAL,
  })

  return data
}
